import Panzoom from '@panzoom/panzoom';
import Swiper, { Navigation } from 'swiper';

let swiper = null;

document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.interactionMap')) return;

    if (window.innerWidth < 866) {
        const elem = document.querySelector('.interactionMap-inner');

        const panzoom = new Panzoom(elem, {
            maxScale: 5,
            contain: 'outside',
            startScale: 1,
        });

        elem.parentElement.addEventListener('wheel', function (event) {
            if (!event.shiftKey) return;
            panzoom.zoomWithWheel(event);
        });

        swiper = new Swiper('.swiper', {
            modules: [Navigation],
            navigation: {
                nextEl: '.interactionMapSlider-control-next',
                prevEl: '.interactionMapSlider-control-prev',
            },
            autoHeight: true,
            loop: true,
        }).on('activeIndexChange', (e) => setActive(e.realIndex));
    }

    ['mouseover', 'mouseout'].forEach((e) => {
        document.addEventListener(e, (e) => {
            const mode = e.type == 'mouseover' ? 'add' : 'remove';
            const classList = e.target.classList;

            if (classList.contains('interactionMapMarker-btn') || classList.contains('interactionMapArea')) {
                const rel = e.target.dataset.rel;
                document
                    .querySelectorAll(
                        `.interactionMapMarker[data-rel="${rel}"], .interactionMapArea[data-rel="${rel}"]`
                    )
                    .forEach((e) => {
                        e.classList[mode]('hover');
                    });
            }
        });
    });

    const closeAllPanels = (e) => {
        document.querySelector('.interactionMap').classList.remove('active');
        document.querySelectorAll(`.interactionMap .active`).forEach((e) => e.classList.remove('active'));
    };

    const setActive = (id) => {
        closeAllPanels();
        document.querySelector('.interactionMap').classList.add('active');
        document.querySelectorAll(`.interactionMap *[data-rel="${id}"]`).forEach((e) => e.classList.add('active'));
    };

    const controlFN = (e) => {
        const id = e.target.dataset.rel;
        if (window.innerWidth < 866) {
            swiper.slideTo(parseInt(id) + 1);
        }

        setActive(id);
    };

    document
        .querySelectorAll('.interactionMapMarker, .interactionMapArea')
        .forEach((e) => e.addEventListener('click', controlFN));

    document
        .querySelectorAll('.interactionMap-fixedClose, .interactionMapPanel-close')
        .forEach((e) => e.addEventListener('click', closeAllPanels));
});
